import format from 'string-format';

import client from '../../client';
import { Search } from './interfaces';

const api = client.extend({ prefixUrl: '/o/search/' });

enum EEndpoints {
  RESULTS = 'results/{language}/{company}/{group}/{keyword}',
}

class SearchApiService {
  static async getResults(language: string, company: string, group: string, keyword: string) {
    return await api.get(format(EEndpoints.RESULTS, { language, company, group, keyword })).json<Search>();
  }
}

export default SearchApiService;
